import { toggleListingLimitExceedPopup } from "@/store/slices";
import { useDispatch } from "react-redux"

export const useListingLimitExceedPopupToggle = () =>{
    const dispatch = useDispatch();

    const handleListingLimitExceedPopupToggle = (args) =>{
        dispatch(toggleListingLimitExceedPopup(args))
    }
    return handleListingLimitExceedPopupToggle;
}